import RAST_UTIL from '../util.urlWriter';
import { setSearchText, setIsInitialized, clear } from './actions';

const thunkClear = ({ preventUrlWrite = false } = {}) => dispatch => { 
  dispatch(clear());
  if (!preventUrlWrite) {
    RAST_UTIL.clearUrl();
  }
}

const thunkSetSearchText = (searchText, { isFuzzySearch = false, preventUrlWrite = false } = {}) => dispatch => {
  dispatch(setSearchText(searchText, { isFuzzySearch }));
  if (!preventUrlWrite) { 
    RAST_UTIL.setValueInUrl(searchText, isFuzzySearch);
  }
};

const thunkLoadStateFromUrl = () => (dispatch) => { 
  if (!RAST_UTIL.CACHE.isLoaded) {
    RAST_UTIL.loadCacheFromUrl();
    const { PROPS: URL_PROPS } = RAST_UTIL.CACHE;
    const { searchText, isFuzzySearch } = URL_PROPS;
    dispatch(thunkSetSearchText(searchText, { isFuzzySearch, preventUrlWrite: true }));
    dispatch(setIsInitialized(true));
  }
}

export { thunkClear, thunkSetSearchText, thunkLoadStateFromUrl };

export default {
  thunkClear,
  thunkSetSearchText,
  thunkLoadStateFromUrl,
};
